import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// scroll to top of the page on routing
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({top: 0, behavior: "instant"});
  }, [pathname]);

  return null;
};

export default ScrollToTop;
